// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"confirmmobilealert_confirmButton__2ATvP"};